<template>
	<div class="visaorder">
		<back-to></back-to>
		<section class="visaorder-content">
			<h2>{{productList.Title}}</h2>
			<div class="visaorder-content_label">
				<label for="">
					<font>套餐类型</font>
					<p>{{productList.JXPrice}}</p>
				</label>
				<label for="">
					<font>计划出行日期</font>
					<p>{{param.startday}}</p>
				</label>
				<label for="">
					<font>购买数量</font>
					<p>{{param.count}}</p>
				</label>
			</div>
			<div class="visaorder-content_chuxing">
				<h3>联系人信息 (用于接收订单反馈)</h3>
				<label for="" @click="travelerShow = true">
					<p>{{getTicketName != ''?getTicketName : '请选择联系人'}}</p>
					<font class="right-arrow"></font>
				</label>
			</div>
			<div class="visaorder-content_Message">
				<h3>备注</h3>
				<label class="visaorder-content_Message-remark">
					<van-field v-model="remark" type="textarea" maxlength="100" placeholder="选填，额外要求可以写在这里，请控制在100字以内"
						show-word-limit />
				</label>
			</div>
		</section>
		<section class="shuoming">
			<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/clause.png" alt="">
			<label for="">
				提交意味着认真阅读并同意相关条款<font>（费用说明、预订须知等）</font>及《甜程旅行安全手册》
			</label>
		</section>

		<section class="choiceBtn">
			<div class="choiceBtn-l">
				<p>价格:</p>
				<font>￥{{param.total}}</font>
			</div>
			<div class="choiceBtn-r" @click="goto">提交订单</div>
		</section>
		<!-- 出行人信息 -->
		<van-popup class="orderPopupt" v-model="travelerShow" round position="bottom"
			@click-overlay="travelerShow = false">
			<div class="orderPopup-sure">
				<span @click="travelerShow = false">取消</span>
				<span @click="travelerShow = false">确认</span>
			</div>
			<div class="orderPopup-add">
				<span @click="$router.push({ path: '/visatraveler',query:{type:0}})">+新增</span>
			</div>
			<div class="orderPopup-list">
				<ul>
					<li v-for="(item,index) in travelerList" :key="index" @click="selectTravelers(index)">
						<img src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_07.png"
							@click.stop="edit(item)" alt="">
						<p>{{item.TravellerName}}</p>
						<span class="orderPopup-lists">
							<img v-if="item.checked"
								src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_08.png"
								alt="">
							<font v-if="!item.checked" class="select-false"></font>
						</span>
					</li>
				</ul>
			</div>
		</van-popup>
		<!-- 提交订单成功 -->
		<van-popup class="orderPopupt orderShow" v-model="orderShow" round position="bottom"
			@click-overlay="orderShow = false">
			<img src="https://m.sweetour.com/images/mini/order-submit-icon.png" alt="">
			<label for="">
				<p class="oo-title-suc">提交订单成功！</p>
				<p class="oo-title-server">您的专属客服将与您联系！请保持电话通畅！</p>
				<p class="oo-title-write">请问是否现在填写出游人资料？</p>
			</label>
			<span class="oo-btn">
				<p class="oo-jump fl" @click='passme'>跳过</p>
				<p class="oo-write fr" @click='writeme'>现在填写</p>
			</span>
		</van-popup>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import BackTo from "@/components/BackTo";
	import {
		Dialog,
		Toast
	} from 'vant'
	export default {
		name: 'visaorder',
		components: {
			BackTo
		},
		data() {
			return {
				param: "",
				productList: [],
				remark: "",
				travelerShow: false,
				travelerList: [],
				getTicketName: "",
				orderShow: false,
				orderID: ''
			}
		},
		created() {
			let param = JSON.parse(this.$route.query.orderParam);
			this.param = param
			console.log(param)
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {
			this.getData()
			this.getTravelerList()
		},
		methods: {
			selectTravelers(e) {
				var selectLength = this.travelerList.filter(item => item.checked == true)
				if (selectLength < 1) {
					this.travelerList[e].checked = !this.travelerList[e].checked
				} else {
					var index = this.travelerList.findIndex(item => item.checked == true)
					this.travelerList[index].checked = !this.travelerList[index].checked
					this.travelerList[e].checked = !this.travelerList[e].checked
				}
				this.getTicketName = this.travelerList[e].TravellerName
			},
			getData() {
				this.$post(
					this.$apiWebsiteSweet + '/api/VisaID', {
						ID: this.param.id
					}
				).then(res => {
					console.log(res)
					this.productList = res.VisaProduct
				})
			},
			getTravelerList() {
				this.$post(
					this.$apiWebsiteSweet + '/NewOrder/GetContactsList', {
						'userID': this.userInfo.userId.toString()
					}
				).then(res => {
					for (let i = 0; i < res.TravellerList.length; i++) {
						res.TravellerList[i].checked = false
					}
					this.travelerList = res.TravellerList
				})
			},
			edit(e) {
				var data = JSON.stringify(e)
				this.$router.push({
					path: '/visatraveler',
					query: {
						object: data
					}
				})
			},
			goto() {
				if (this.getTicketName == '') {
					Toast("请选择联系人")
					return
				}
				var selectLength = this.travelerList.filter(item => item.checked == true)
				let contact_array = []
				selectLength[0].TravellerInfos.forEach(element => {
					contact_array.push({
						TravellerTemplateTagID: element.TravellerTemplateTagID,
						TagValue: element.TagValue
					})
				});
				var jsonData = {
					'ProductID': this.param.id, // 产品ID
					'ProductTypeID': 3, // 产品类型ID
					'WebUserID': this.userInfo.userId, // 用户ID
					'Price_01': this.param.total, // 商品原价
					'Price_02': this.param.total, // 优惠后的价格
					'Price_04': this.param.total, // 优惠的价格
					'OrderNum': this.param.count, // 订单数量
					'ActiveID': [], // 优惠ID列表
					'Mark': this.remark, // 备注
					'Source': 'Min', // 下单来源
					'Contacts': {
						// 联系人（下单时选的联系人）
						'ID': 0,
						'TravellerID': selectLength[0].TravellerID,
						'Info': contact_array
					},
					VisaInfo: {
						// 签证信息
						StartDate: this.param.startday
					}
				}
				this.$post(
					this.$apiWebsiteSweet + '/NewOrder/SubmitOrder', jsonData
				).then(res => {
					if (res.IsSuccess) {
						this.orderShow = true
						this.orderID = res.OrderID
					}

				})
			},
			passme() {
				var jsonData = {
					orderID: this.orderID,
					isComplete: false
				}
				this.$post(
					this.$apiWebsiteSweet + '/NewOrder/SetOrderStatus', jsonData
				).then(res => {
					this.$router.push({
						path: '/orderStatus',
						query: {
							orderId: this.orderID
						}
					})
				})
			},
			writeme() {
				this.$router.push({
					path: '/call',
					query: {
						orderId: this.orderID
					}
				})
			}
		}
	}
</script>

<style scoped>
	.visaorder-content {
		width: 100%;
		padding: 0 48px;
		box-sizing: border-box;
	}

	.visaorder-content h2 {
		font-size: 36px;
		padding-top: 26px;
	}

	.visaorder-content_label label {
		width: 100%;
		display: flex;
		align-items: center;
		font-weight: bold;
		color: #000;
		font-size: 28px;
		margin-top: 48px;
	}

	.visaorder-content_label font {
		font-size: 30px;
		color: #666;
		font-weight: normal;
		width: 40%;
	}

	.visaorder-content_label p {
		width: 60%;
	}

	.visaorder-content_chuxing {
		width: 100%;
		margin-top: 48px;
	}

	.visaorder-content_chuxing h3 {
		font-size: 35px;
		color: #000;
		margin: 4px 0;
		font-weight: normal;
	}

	.visaorder-content_chuxing label {
		display: flex;
		align-items: center;
		font-size: 30px;
		color: #666;
		background: #f6f6f6;
		height: 72px;
		padding: 0 24px;
		line-height: 72px;
		margin-top: 40px;
		width: 100%;
		box-sizing: border-box;
		justify-content: space-between;
	}

	.right-arrow {
		display: inline-block;
		width: 36px;
		height: 36px;
		position: relative;
	}

	.right-arrow::after {
		display: inline-block;
		content: " ";
		height: 18px;
		width: 18px;
		border-width: 4px 4px 0 0;
		border-color: #000;
		border-style: solid;
		transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		position: absolute;
		top: 0;
		right: 6px;
		margin-top: 9px;
		border-top-width: 2px;
		border-right-width: 2px;
		border-bottom-width: 0px;
		border-left-width: 0px;
		border-top-color: rgb(0, 0, 0);
		border-right-color: rgb(0, 0, 0);
		border-bottom-color: rgb(0, 0, 0);
		border-left-color: rgb(0, 0, 0);
		border-top-style: solid;
		border-right-style: solid;
		border-bottom-style: solid;
		border-left-style: solid;
	}

	.visaorder-content_Message {
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-top: 48px;
	}

	.visaorder-content_Message h3 {
		font-size: 35px;
		color: #000;
		margin: 4px 0;
		font-weight: normal;
	}

	.visaorder-content_Message-remark {
		width: 85%;
		border: none;
		background: #f9f9f9;
		font-size: 24px;
	}

	.visaorder-content_Message-remark .van-cell {
		background: #f9f9f9;
		padding: 10px !important;
		line-height: 38px;
	}

	.shuoming {
		width: 100%;
	}

	.shuoming img {
		height: 27px;
		width: 75px;
		display: block;
		margin-left: 45px;
		margin-top: -3px;
	}

	.shuoming label {
		font-size: 22px;
		color: #666;
		background: #fff2f0;
		padding: 15px 25px;
		display: inline-block;
		box-sizing: border-box;
	}

	.shuoming font {
		color: #759ef8;
	}

	.choiceBtn {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 96px;
		border-top: 1px solid #e5e4e3;
		background-color: #fff;
	}

	.choiceBtn div {
		height: 96px;
		display: flex;
		align-items: center;
	}

	.choiceBtn-r {
		width: 286px;
		background: #ff6d00;
		font-size: 36px;
		color: #fff;
		border: 0;
		justify-content: center;
	}

	.choiceBtn-l {
		color: #ff6d00;
		font-size: 48px;
		display: inline-block;
		padding-left: 28px;
		box-sizing: border-box;
	}

	.choiceBtn-l p {
		font-size: 28px;
		color: #333;
		margin-top: 12px;
		padding-right: 7px;
	}

	.orderPopupt {
		width: 100%;
		padding: 30px 0;
		height: 600px;
	}

	.orderPopup-sure {
		display: flex;
		justify-content: space-between;
		width: 100%;
		font-size: 30px;
		border-bottom: 1px solid #f2f2f2;
		padding: 0 70px 30px 70px;
		box-sizing: border-box;
	}

	.orderPopup-sure span:first-child {
		color: #ccc;
	}

	.orderPopup-sure span:last-child {
		color: #ff6d00;
	}

	.orderPopup-add {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.orderPopup-add span {
		margin-top: 30px;
		background: #f5f5f5;
		height: 80px;
		font-size: 40px;
		color: #ff6d00;
		text-align: center;
		line-height: 80px;
		border-radius: 5px;
		width: 100%;
	}

	.orderPopup-list {
		width: 100%;
		padding: 10px 50px;
		box-sizing: border-box;
	}

	.orderPopup-list li {
		display: flex;
		align-items: center;
		border-bottom: #f5f5f5 solid 1px;
		font-size: 30px;
		color: #333;
		height: 100px;

	}

	.orderPopup-list li p {
		margin-left: 30px;
	}

	.orderPopup-list img {
		width: 28px;
		height: 28px;
	}

	.select-false {
		display: block;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		border: 1px solid #666;
		box-sizing: border-box;
	}

	.orderPopup-lists {
		margin-left: auto;
	}

	.orderShow {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
	}

	.orderShow img {
		height: 116px;
		width: 116px;
	}

	.oo-title-suc,
	.oo-title-server,
	.oo-title-write {
		text-align: center;
	}

	.oo-title-suc {
		font-size: 36px;
		color: #666;
		font-weight: bolder;
		height: 80px;
		line-height: 80px;
	}

	.oo-title-server {
		color: #666;

	}

	.oo-title-server,
	.oo-title-write {
		font-size: 30px;
	}

	.oo-title-write {
		color: #333;
		margin-bottom: 80px;
	}

	.oo-btn {
		display: flex;
		align-items: center;
		justify-content: space-around;
		width: 100%;
	}


	.oo-jump {
		background: #f7f8f8;
		color: #333;
		border: 2px solid #b5b5b6;
		margin-left: 6px;
		width: 260px;
		height: 76px;
		line-height: 76px;
		text-align: center;
	}

	.oo-write,
	.oo-jump {
		font-size: 32px;
		border-radius: 5px;
	}


	.oo-write {
		color: #fff;
		background: #ff6d00;
		margin-right: 1px;
		line-height: 80px;
		width: 264px;
		height: 80px;
		text-align: center;
	}
</style>
